
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { Truck, Coins, Hammer, Leaf, Droplets } from "lucide-react";

const NosServices = () => {
  const services = [
    {
      title: "Location de bennes",
      description: "Location de bennes pour tous vos projets de déchets",
      icon: Truck,
      path: "/nos-services/location-bennes",
      color: "bg-fabre-green"
    },
    {
      title: "Achat de métaux",
      description: "Rachat de métaux au meilleur prix du marché",
      icon: Coins,
      path: "/nos-services/achat-metaux",
      color: "bg-fabre-darkgreen"
    },
    {
      title: "Démolition",
      description: "Services de démolition professionnels",
      icon: Hammer,
      path: "/nos-services/demolition",
      color: "bg-fabre-gray"
    },
    {
      title: "Prestation RSE",
      description: "Solutions environnementales responsables",
      icon: Leaf,
      path: "/nos-services/prestation-rse",
      color: "bg-fabre-lightgreen"
    },
    {
      title: "Collecte huiles minérales",
      description: "Collecte et recyclage d'huiles minérales usagées",
      icon: Droplets,
      path: "/services/huiles-minerales",
      color: "bg-fabre-darkgreen"
    },
    {
      title: "Collecte huiles alimentaires",
      description: "Collecte et valorisation des huiles de friture usagées",
      icon: Droplets,
      path: "/services/huiles-alimentaires",
      color: "bg-fabre-green"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Nos Services - Groupe Fabre Environnement"
        description="Découvrez tous nos services : location de bennes, achat de métaux, démolition, prestations RSE, collecte d'huiles minérales et alimentaires. Solutions complètes."
        canonical="/nos-services"
      />
      <Navbar />
      
      <main className="flex-1 mt-16">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-fabre-green to-fabre-darkgreen text-white py-16 animate-fade-in">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">Nos Services</h1>
              <p className="text-xl opacity-90">
                Solutions complètes de gestion des déchets et recyclage pour 
                particuliers, professionnels et collectivités.
              </p>
            </div>
          </div>
        </div>

        {/* Services Grid */}
        <section className="py-16 bg-background">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {services.map((service) => {
                const IconComponent = service.icon;
                return (
                  <Link
                    key={service.path}
                    to={service.path}
                    className="block group"
                    aria-label={`${service.title} - En savoir plus`}
                  >
                    <div className="bg-background text-foreground border rounded-xl p-8 shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5 hover-scale animate-enter focus-within:ring-2 focus-within:ring-fabre-green/40">
                      <div className={`w-16 h-16 ${service.color} rounded-xl flex items-center justify-center mb-6 ring-1 ring-white/20 shadow-md transition-transform group-hover:scale-105`}>
                        <IconComponent className="h-8 w-8 text-white" />
                      </div>
                      <h3 className="text-2xl font-bold text-fabre-gray mb-3">{service.title}</h3>
                      <p className="text-muted-foreground mb-6">{service.description}</p>
                      <div className="story-link text-fabre-green font-medium">
                        En savoir plus →
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-fabre-gray mb-6">
              Besoin d'un devis personnalisé ?
            </h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Contactez-nous pour obtenir un devis gratuit et personnalisé 
              selon vos besoins spécifiques.
            </p>
            <Link
              to="/contact"
              className="inline-block bg-fabre-green hover:bg-fabre-darkgreen text-white px-8 py-3 rounded-md font-medium transition-colors"
            >
              Demander un devis
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default NosServices;
